import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = {
  key: 0,
  class: "card seq-card mb-5 mb-xl-10"
}
const _hoisted_3 = { class: "card-body pt-9 pb-0" }
const _hoisted_4 = { class: "card-header border-0 pt-5" }
const _hoisted_5 = { class: "card-title align-items-center" }
const _hoisted_6 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_7 = { class: "card-label fw-bold fs-3" }
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = { class: "row g-5" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "ps-4 pe-4" }
const _hoisted_15 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "fw-semibold text-gray-800" }, "ED PLAN MATCH", -1)
const _hoisted_17 = { class: "text-muted fs-8" }
const _hoisted_18 = { class: "ps-4 pe-4" }
const _hoisted_19 = { class: "fw-semibold text-gray-800" }
const _hoisted_20 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_21 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_22 = { class: "ps-4 pe-4" }
const _hoisted_23 = { class: "fw-semibold text-gray-800" }
const _hoisted_24 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_25 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "ps-4 pe-4" }
const _hoisted_28 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_29 = { class: "d-flex flex-column" }
const _hoisted_30 = { class: "flex-grow-1" }
const _hoisted_31 = { class: "pt-5 text-center" }
const _hoisted_32 = { class: "seq-badge seq-badge--success" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_ECP_EDP_DashboardNavigator = _resolveComponent("ECP_EDP_DashboardNavigator")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_apexchart = _resolveComponent("apexchart")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 20,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      (_ctx.pt != 'ovi')
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_ECP_EDP_DashboardNavigator)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card"]
      }, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h3", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
            ]),
            _createVNode("span", _hoisted_7, "Account Info - " + _toDisplayString(_ctx.user.usid), 1)
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("table", _hoisted_12, [
                  _createVNode("tbody", null, [
                    (_ctx.pt == 'edp')
                      ? (_openBlock(), _createBlock("tr", _hoisted_13, [
                          _createVNode("td", _hoisted_14, [
                            _createVNode("div", _hoisted_15, [
                              _createVNode("div", null, [
                                _hoisted_16,
                                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.edplanpairs) + " / " + _toDisplayString(_ctx.maxUturn), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summary1, (item, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: 's1-' + index
                      }, [
                        _createVNode("td", _hoisted_18, [
                          _createVNode("div", _hoisted_19, _toDisplayString(item.tdesc.toUpperCase()), 1),
                          (item.vAmt.match('^[1-9]\\d*(\\.\\d+)?$'))
                            ? (_openBlock(), _createBlock("div", _hoisted_20, _toDisplayString(_ctx.numberWithCommas(Number(item.vAmt).toFixed(2))), 1))
                            : (_openBlock(), _createBlock("div", _hoisted_21, _toDisplayString(item.vAmt), 1))
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summary2, (item, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: 's2-' + index
                      }, [
                        _createVNode("td", _hoisted_22, [
                          _createVNode("div", _hoisted_23, _toDisplayString(item.tdesc.toUpperCase()), 1),
                          (item.vAmt.match('^[1-9]\\d*(\\.\\d+)?$'))
                            ? (_openBlock(), _createBlock("div", _hoisted_24, _toDisplayString(_ctx.numberWithCommas(Number(item.vAmt).toFixed(2))), 1))
                            : (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(item.vAmt), 1))
                        ])
                      ]))
                    }), 128)),
                    (_ctx.isShowMore == true && _ctx.ccode != 15)
                      ? (_openBlock(), _createBlock("tr", _hoisted_26, [
                          _createVNode("td", _hoisted_27, [
                            _createVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-seq-green",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMoreAccountInfo()))
                            }, " Show More ")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            (_ctx.ccode == 0 && _ctx.packageType != 'REGV4Z01')
              ? (_openBlock(), _createBlock("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", _hoisted_30, [
                      _createVNode(_component_apexchart, {
                        class: "mixed-widget-4-chart",
                        options: _ctx.chartOptions,
                        series: _ctx.series,
                        height: "500",
                        type: "radialBar"
                      }, null, 8, ["options", "series"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _createVNode("span", _hoisted_32, " You have PhP" + _toDisplayString(_ctx.numberWithCommas(_ctx.carfundMonitor.car_fund.toFixed(2))) + " in your car fund. ", 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, _ctx.isLoading == false]
    ])
  ], 64))
}